// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
import stickybits, {StickyBits} from 'stickybits'

@Component({
    mixins: [template]
})
export class Sticky extends Vue {

    @Prop({default: 'top'})
    public verticalPosition!: 'top' | 'bottom'

    @Prop({default: 0})
    public stickyBitStickyOffset!: number

    private instance?: StickyBits

    get stickyBitsOptions() {
        return {
            useStickyClasses: true,
            stickyClass: `${this.$appPrefix}-sticky--is-sticky`,
            stuckClass: `${this.$appPrefix}-sticky--is-stuck`,
            verticalPosition: this.verticalPosition,
            stickyBitStickyOffset: this.stickyBitStickyOffset
        }
    }

    @Watch('stickyBitsOptions')
    public onStickyBitOptionsChanged() {
        if (this.instance) {
            this.instance.update(this.stickyBitsOptions);
            this.instance.els.forEach((el: Element) => {
                const verticalPositionStyle = this.verticalPosition === 'top' ? `${this.stickyBitStickyOffset}px` : ''
                let htmlEl = <HTMLElement> el;
                htmlEl.style[this.verticalPosition] = verticalPositionStyle
            })
        }
    }

    public mounted() {
        this.instance = stickybits(this.$el, this.stickyBitsOptions);
    }

    public destroyed() {
        if (this.instance) {
            this.instance.cleanup()
        }
    }
}
